<template>
  <svg
    id="Messages"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <rect
      id="Rectangle_1605"
      data-name="Rectangle 1605"
      width="16"
      height="16"
      fill="none"
    />
    <rect
      id="Rectangle_1456"
      data-name="Rectangle 1456"
      width="14"
      height="12"
      rx="3"
      transform="translate(1 2)"
      fill="none"
      stroke="#2d323c"
      stroke-width="1"
    />
    <path
      id="Path_2101"
      data-name="Path 2101"
      d="M1.207,2.774,6.591,7.493a1.7,1.7,0,0,0,2.284-.007l5.388-4.779"
      transform="translate(0.099 0.556)"
      fill="none"
      stroke="#2d323c"
      stroke-linecap="square"
      stroke-width="1"
    />
  </svg>
</template>

<script>
export default {
  name: 'Send',
}
</script>

<style lang="scss" scoped></style>
